var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"percentage-input-wrapper"},[_c('v-currency-field',_vm._b({staticClass:"classic-text-field",attrs:{"disabled":_vm.disabled,"rules":[
      (v) =>
        RegExp('^[0-9]{1,13}(\.[0-9]*)?$').test(v.replace(/,/gi, '')) ||
        'Número Inválido.',
    ]},nativeOn:{"keydown":function($event){return _vm.checkMaxSafeInteger($event)}},model:{value:(_vm.computedValue),callback:function ($$v) {_vm.computedValue=$$v},expression:"computedValue"}},'v-currency-field',_vm.percentage_config,false)),_c('div',{staticClass:"label-prepend"},[_vm._v("\n    "+_vm._s(_vm.label)+"\n  ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }